export default function applySupportPhone(cityName) {
  const phones = $('article.v4.storages_map').data('support_phones');
  if (!phones) { return; }

  const phone = phones.cities[cityName] || phones.default;
  const regionalCssClasses = Object.values(phones.cities)
    .map(({ cssClass }) => cssClass)
    .join(' ');

  $('[data-support_phone]').each((_index, node) => {
    $(node)
      .attr('href', phone.url)
      .text(phone.label)
      .removeClass(regionalCssClasses)
      .addClass(phone.cssClass || '');
  });

  // модалка контактов монтируется по первому клику и читает пропсы
  // из data триггера через jquery, поэтому обновляем и кэш .data()
  $('[data-phone_url]').each((_index, node) => {
    $(node)
      .attr('data-phone_url', phone.url)
      .data('phone_url', phone.url)
      .attr('data-phone_class', phone.cssClass || '')
      .data('phone_class', phone.cssClass || '');
  });
}
